import { render, staticRenderFns } from "./AddImageModal.vue?vue&type=template&id=48f99de6&scoped=true"
import script from "./AddImageModal.vue?vue&type=script&lang=js"
export * from "./AddImageModal.vue?vue&type=script&lang=js"
import style0 from "./AddImageModal.vue?vue&type=style&index=0&id=48f99de6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f99de6",
  null
  
)

export default component.exports